<style scoped>
  *{
    padding:0;
    margin:0;
  }
  .el-header{
    line-height: 60px;
    text-align: left;
    padding: 0;
  }
  .el-main {
    background-color: #ffffff;
    color: #333;
    text-align: left;
    margin: 20px 30px;
  }
  body > .el-container {
    width: 100%;
    margin-bottom: 40px;
  }
</style>
<template>
  <div style="height:100%;">
    <el-header><topbar/></el-header>
    <el-container style="height:calc(100vh - 60px);width:100%">
      <el-aside width="240px"><left/></el-aside>
      <el-main><router-view></router-view></el-main>
    </el-container>
  </div>
</template>
<script>
import topbar from '@/components/layout/topbar'
import left from '@/components/layout/left'
export default {
  data () {
    return {
    }
  },
  components:{
    topbar,left
  }
}
</script>







// WEBPACK FOOTER //
// src/view/layout.vue